var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"locale-switcher primary",attrs:{"elevation":"0"},on:{"click":function($event){return _vm.toggleLocale()}}},[_c('v-icon',{staticClass:"mr-1",attrs:{"dense":""}},[_vm._v("mdi-web")]),_vm._v(" "+_vm._s(_vm.locales[_vm.$i18n.locale].acronym)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }